import { Button, Tooltip } from "antd"
import { getThemedImage, getTranslated } from "../../../utils/CommonUtils"
import { ACTION_ITEMS, ADD, DELETE, COPY, EDIT, MOVE } from "../../../utils/Constants"
import { useDispatch, useSelector } from "react-redux"
import { setPkActionMode, setPKParentActionMode, setProgKeysInstruction } from "../../../store/reducers/ProgKeysReducer"
import { useEffect } from "react"


const ProgKeysActionbar = (props) => {

    const dict = useSelector(state => state.common.dict)
    const pkActionMode = useSelector(state => state.progkeys.pkActionMode)
    const pkParentActionMode = useSelector(state => state.progkeys.pkParentActionMode)

    const dispatch = useDispatch()

    useEffect(() => {
        switch (pkParentActionMode) {
            case ADD:
                dispatch(setProgKeysInstruction(getTranslated(dict, "MSG_ADD_PROGKEYS")))
                break
            case EDIT:
                dispatch(setProgKeysInstruction(getTranslated(dict, "MSG_SELECT_PROGKEY")))
                break
            case COPY:
                dispatch(setProgKeysInstruction(getTranslated(dict, "MSG_COPY_SELECT_PK")))
                break
            case MOVE:
                dispatch(setProgKeysInstruction(getTranslated(dict, "MSG_MOVE_SELECT_PK")))
                break
            case DELETE:
                dispatch(setProgKeysInstruction(getTranslated(dict, "MSG_DELETE_SELECT_PK")))
                break
            default:
                break
        }
    }, [pkParentActionMode])

    const handleAction = (action) => {
        if (pkParentActionMode !== action) {
            // const updatedAction = pkParentActionMode === action ? ADD : action
            dispatch(setPkActionMode(action))
            dispatch(setPKParentActionMode(action))
        }
    }


    return <div className={`key-action-wrap`}>
        {ACTION_ITEMS.map(item => {
            const isActive = pkActionMode === item.action || (item.action === pkParentActionMode)
            const transaltedTitle = getTranslated(dict, item.title)

            const disableStyle = { pointerEvents: "none", opacity: "0.5" }
            const isActionActive = ((item.action === pkParentActionMode) || (pkActionMode === ADD))

            return <Tooltip title={transaltedTitle}>
                <Button
                    shape="circle"
                    style={isActionActive ? {} : disableStyle}
                    className={`prog-action ${isActive ? "active" : ""} ${(item.action !== DELETE) ? "" : pkActionMode === DELETE ? "pk-del-icon pk-del-active" : "pk-del-icon"}`} //Additional class for DELETE mode to handle the red icon & border
                    icon={<img src={getThemedImage(`${(isActive) ? "dark" : "light"}-${item.icon}.svg`)} alt={transaltedTitle} />}
                    onClick={() => handleAction(item.action)}
                />
            </Tooltip>
        })}
    </div>
}

export default ProgKeysActionbar